/**
 * Inline macro summary used in the meal-group accordion header.
 * Renders e.g.  "212.0 kcal • 12.0g protein • 30.0g carbs • 5.0g fat"
 */
import * as React from "react";

interface NutrientReadingsProps {
  energy?: number;
  protein?: number;
  carbs?: number;
  fat?: number;
}

export const NutrientReadings: React.FC<NutrientReadingsProps> = ({
  energy,
  protein,
  carbs,
  fat,
}) => {
  // Energy renders as a whole number so it matches the per-row kcal
  // (also rounded to 0 dp). Macros stay at 1 dp.
  const parts: { display: string; unit: string; label: string }[] = [];
  if (energy !== undefined && energy !== null)
    parts.push({
      display: Math.round(energy).toString(),
      unit: "",
      label: "kcal",
    });
  if (protein !== undefined && protein !== null)
    parts.push({ display: protein.toFixed(1), unit: "g", label: "protein" });
  if (carbs !== undefined && carbs !== null)
    parts.push({ display: carbs.toFixed(1), unit: "g", label: "carbs" });
  if (fat !== undefined && fat !== null)
    parts.push({ display: fat.toFixed(1), unit: "g", label: "fat" });

  if (parts.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5 z-body">
      {parts.map((part, idx) => (
        <React.Fragment key={part.label}>
          {idx > 0 && <span className="text-muted-foreground">•</span>}
          <span>
            <span className="z-body-md text-foreground">
              {part.display}
              {part.unit}
            </span>
            <span className="text-muted-foreground ml-1">{part.label}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};
